import { render } from "./SimpleRowNuggets2.vue?vue&type=template&id=3d5f564e"
import script from "./SimpleRowNuggets2.vue?vue&type=script&lang=js"
export * from "./SimpleRowNuggets2.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ContentCreator/InfoNugget/SimpleRowNuggets2.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3d5f564e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3d5f564e', __exports__)) {
    api.reload('3d5f564e', __exports__)
  }
  
  module.hot.accept("./SimpleRowNuggets2.vue?vue&type=template&id=3d5f564e", () => {
    api.rerender('3d5f564e', render)
  })

}


export default __exports__